import {MARKER_START} from './MarkerStartTypes'

export const changeMarkerStart = markerStart => {
    return {
        type: MARKER_START,
        load: markerStart
    }
}

export const selectNewMarkerStart = (markerStart) => {

    return (dispatch) => {
        
        dispatch(changeMarkerStart(markerStart))
    }

}